<template>
  <div>
    <div class="orange-bg">
      <div class="orange-left">
        <div class="orange-item"></div>
        <div class="orange-item"></div>
      </div>
      <div class="orange-right">
        <div class="orange-item"></div>
        <div class="orange-item"></div>
        <div class="orange-item"></div>
      </div>
    </div>
    <div class="orange-item-price">
      <!-- <div class="orange-item-price-bg" @click="toBuy"> -->
      <div class="orange-item-price-bg">
        <el-image :src="configState.home365Img.value.data" fit="fill" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useConfigStore } from '@/stores'
import { storeToRefs } from 'pinia'

const configStore = useConfigStore()
const configState = storeToRefs(configStore)

const props = defineProps({
  buyClick: {
    type: Function,
    required: true
  }
})

const toBuy = () => {
  props.buyClick('all')
}
</script>

<style scoped>
.orange-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 147px;
  background: rgba(246, 180, 67, 1);
  display: flex;
  justify-content: space-between;
  padding: 0 130px 0 284px;
  box-sizing: border-box;
  align-items: center;
  margin-top: 950px;
}
.orange-left,
.orange-right {
  display: flex;
  gap: 10px;
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
  padding: 0 16px;
  align-items: center;
}
.orange-left .orange-item:nth-of-type(1) {
  width: 125px;
  height: 26px;
  background: url(@/assets/images/orange-item-11.png) no-repeat;
  background-size: 100% 100%;
}
.orange-left .orange-item:nth-of-type(2) {
  width: 107px;
  height: 45px;
  background: url(@/assets/images/orange-item-02.png) no-repeat;
  background-size: 100% 100%;
  background-origin: content-box;
  border-left: 1px solid #fff;
  padding-left: 10px;
}
.orange-right .orange-item:nth-of-type(1) {
  width: 105px;
  height: 30px;
  background: url(@/assets/images/orange-item-03.png) no-repeat;
}
.orange-right .orange-item:nth-of-type(2) {
  width: 133px;
  height: 40px;
  background: url(@/assets/images/orange-item-04.png) no-repeat;
  background-size: 100% 100%;
  background-origin: content-box;
  border-left: 1px solid #fff;
  padding-left: 10px;
}
.orange-right .orange-item:nth-of-type(3) {
  width: 131px;
  height: 37px;
  background: url(@/assets/images/orange-item-05.png) no-repeat;
  background-size: 100% 100%;
  background-origin: content-box;
  border-left: 1px solid #fff;
  padding-left: 10px;
}
.orange-item-price {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(90px);
  z-index: 3;
  width: 708px;
  height: 358px;
}
.orange-item-price-bg {
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
/* .orange-item-price-bg:hover {
  transform: scale(1.1);
  transition: all 0.2s ease-in-out;
} */
.orange-item-price-bg {
  transform: scale(1);
  transition: all 0.2s ease-in-out;
}
</style>